import { createFileRoute, redirect } from "@tanstack/react-router";
import { trpc } from "@/trpc";
import { queryClient } from "@/ajax/queryClient";
import { TRPCClientError } from "@trpc/client";
import OrgOnboardingContainer from "@/features/onboarding/components/OrgOnboardingContainer";

export const Route = createFileRoute("/_org/org-onboarding/")({
  beforeLoad: async () => {
    const [userResponse] = await Promise.allSettled([
      queryClient.fetchQuery(trpc.user.getUser.queryOptions()),
    ]);

    if (userResponse.status === "rejected") {
      if (userResponse.reason instanceof TRPCClientError) {
        if (userResponse.reason.data?.code === "UNAUTHORIZED") {
          throw redirect({
            to: "/auth-org/signin",
          });
        }
      }
    }
  },
  component: OrgOnboardingPage,
});

function OrgOnboardingPage() {
  const { user } = Route.useRouteContext();

  if (!user) {
    return null;
  }

  return <OrgOnboardingContainer user={user} />;
}
